import { useCallback } from 'react';

import { EMPTY_ARRAY } from '@e-socna/empty';

import { useReferencesContext } from '../../../contexts/ReferencesContext/hooks/useReferencesContext.hook';

import type { CompatibleSectionTemplatesFormValues } from '../types/compatible-section-templates-form-values.type';
import type { SubmitHandler } from '../types/submit-handler.type';

import type { CompatibleSectionTemplates_SectionTemplates } from './useFindAllCompatibleSectionTemplatesQuery.hook';

interface Params {
  readonly compatibleSectionTemplates?: readonly CompatibleSectionTemplates_SectionTemplates[];
  readonly handleSubmit: SubmitHandler;
}

export const useCompatibleSectionTemplatesSubmit = ({
  compatibleSectionTemplates,
  handleSubmit: pHandleSubmit,
}: Readonly<Params>) => {
  const { contentOriginsCodeMap } = useReferencesContext();

  const handleSubmit = useCallback(
    (
      values: CompatibleSectionTemplatesFormValues,
      {
        setSubmitting,
      }: Readonly<{ setSubmitting: (isSubmitting: boolean) => void }>,
    ) => {
      pHandleSubmit(
        compatibleSectionTemplates?.filter((section) =>
          values.sectionTemplateIdsToInsert.includes(section._id),
        ) ?? EMPTY_ARRAY,
        contentOriginsCodeMap.Catalog._id,
      );
      setSubmitting(false);
    },
    [
      compatibleSectionTemplates,
      contentOriginsCodeMap.Catalog._id,
      pHandleSubmit,
    ],
  );

  return { handleSubmit };
};
